import {
  FaHome,
  FaCalendarCheck,
  FaUsers,
  FaUserCheck,
  FaHandshake,
  FaShareAlt,
  FaShieldAlt,
  FaPhoneSquareAlt,
  FaBell,
  FaBuilding,
  FaChartBar,
  FaUserPlus,
  FaTasks,
  FaColumns,
  FaFilePdf,
  FaFileSignature,
  FaGlobe,
  FaPassport,
  FaFolderOpen,
  FaCodeBranch,
  FaRandom,
  FaGraduationCap,
  FaBook,
  FaUniversity,
  FaAward,
  FaClipboardCheck,
  FaBriefcase,
  FaSitemap,
  FaUmbrellaBeach,
  FaCalendarDay,
  FaMoneyCheckAlt,
  FaReceipt,
  FaFileInvoiceDollar,
  FaHandHoldingUsd,
  FaPercent,
  FaCoins,
} from "react-icons/fa";
import {
  MdOutlineCardMembership,
  MdOutlineSecurity,
  MdPerson,
  MdPersonOutline,
  MdSettings,
} from "react-icons/md";
import { isSuperAdminRole } from "../../routes/roles";

/** Admin CRM menu — grouped like Meta Developer Console sections. */
export const adminMenuGroups = [
  {
    id: "overview",
    label: "Overview",
    items: [
      { path: "/dashboard", name: "Dashboard", icon: <FaHome />, moduleKey: "dashboard" },
    ],
  },
  {
    id: "leads",
    label: "Leads & Pipeline",
    collapsible: true,
    defaultOpen: true,
    icon: <FaTasks />,
    items: [
      { path: "/leads", name: "Leads", icon: <FaUserPlus />, moduleKey: "leads" },
      { path: "/leadassigned", name: "Assigned Leads", icon: <FaTasks />, moduleKey: "assignedLeads" },
      { path: "/pendingfollowups", name: "Pending Follow-ups", icon: <FaBell />, moduleKey: "pendingFollowUps" },
      { path: "/calendar", name: "Calendar", icon: <FaCalendarCheck />, moduleKey: "assignedLeads" },
      { path: "/kanban", name: "Kanban Pipeline", icon: <FaColumns />, moduleKey: "kanban" },
    ],
  },
  {
    id: "immigration",
    label: "Immigration",
    collapsible: true,
    icon: <FaPassport />,
    items: [
      { path: "/immigration/applicants", name: "Applicants", icon: <FaUserCheck />, moduleKey: "applicants" },
      { path: "/immigration/cases", name: "Cases", icon: <FaFolderOpen />, moduleKey: "cases" },
      { path: "/immigration/countries", name: "Countries", icon: <FaGlobe />, moduleKey: "countries" },
      { path: "/immigration/visa-types", name: "Visa Types", icon: <FaPassport />, moduleKey: "visaTypes" },
      { path: "/immigration/documents", name: "Documents", icon: <FaFilePdf />, moduleKey: "documentTemplates" },
      { path: "/immigration/counselling", name: "Counselling", icon: <FaPhoneSquareAlt />, moduleKey: "counselling" },
      { path: "/immigration/appointments", name: "Appointments", icon: <FaCalendarCheck />, moduleKey: "appointments" },
      { path: "/immigration/payments", name: "Payments", icon: <FaChartBar />, moduleKey: "casePayments" },
      { path: "/immigration/assignment-rules", name: "Assignment Rules", icon: <FaRandom />, moduleKey: "assignmentRules" },
    ],
  },
  {
    id: "education",
    label: "Education",
    collapsible: true,
    icon: <FaGraduationCap />,
    items: [
      { path: "/education/institutions", name: "Institutions", icon: <FaUniversity />, moduleKey: "institutions" },
      { path: "/education/courses", name: "Courses", icon: <FaBook />, moduleKey: "courses" },
      { path: "/education/students", name: "Students", icon: <FaUserCheck />, moduleKey: "students" },
      { path: "/education/admissions", name: "Admissions", icon: <FaFileSignature />, moduleKey: "admissions" },
      { path: "/education/fees", name: "Fees", icon: <FaChartBar />, moduleKey: "admissions" },
      { path: "/education/document-templates", name: "Doc Templates", icon: <FaFilePdf />, moduleKey: "admissions" },
      { path: "/education/counselling", name: "Counselling", icon: <FaPhoneSquareAlt />, moduleKey: "educationCounselling" },
      { path: "/education/scholarships", name: "Scholarships", icon: <FaAward />, moduleKey: "scholarships" },
      { path: "/education/exams", name: "Exams", icon: <FaClipboardCheck />, moduleKey: "exams" },
      { path: "/education/student-attendance", name: "Student Attendance", icon: <FaUserCheck />, moduleKey: "studentAttendance" },
      { path: "/education/placements", name: "Placements", icon: <FaBriefcase />, moduleKey: "placements" },
    ],
  },
  {
    id: "sales",
    label: "Sales & Inventory",
    collapsible: true,
    icon: <FaBuilding />,
    items: [
      { path: "/buyers", name: "Buyers", icon: <FaUserCheck />, moduleKey: "buyers" },
      { path: "/propertylisting", name: "Property Listing", icon: <FaBuilding />, moduleKey: "propertyListing" },
      { path: "/bookings", name: "Bookings", icon: <FaFileSignature />, moduleKey: "propertyListing" },
      { path: "/builders", name: "Builders / Partners", icon: <FaHandshake />, moduleKey: "builders" },
      { path: "/builders/listings", name: "Published to partners", icon: <FaShareAlt />, moduleKey: "builders" },
      { path: "/builders/protection", name: "Partner protection", icon: <FaShieldAlt />, moduleKey: "builders" },
      { path: "/builders/commissions", name: "Partner commissions", icon: <FaPercent />, moduleKey: "builders" },
      { path: "/reports", name: "Reports", icon: <FaChartBar />, moduleKey: "reports" },
      { path: "/analytics/revenue", name: "Revenue analytics", icon: <FaCoins />, moduleKey: "marketingAnalytics" },
    ],
  },
  {
    id: "social",
    label: "Social Media",
    collapsible: true,
    icon: <FaShareAlt />,
    items: [
      { path: "/social/dashboard", name: "Overview", icon: <FaHome />, moduleKey: "socialMediaAutomation" },
      { path: "/social/content", name: "Content Studio", icon: <FaFileSignature />, moduleKey: "socialMediaAutomation", matchPaths: ["/social/content"] },
      { path: "/social/templates", name: "Templates", icon: <FaFilePdf />, moduleKey: "socialMediaAutomation", matchPaths: ["/social/templates"] },
      { path: "/social/campaigns", name: "Campaigns", icon: <FaChartBar />, moduleKey: "socialMediaAutomation", matchPaths: ["/social/campaigns"] },
      { path: "/social/calendar", name: "Calendar", icon: <FaCalendarCheck />, moduleKey: "socialMediaAutomation" },
      { path: "/social/publishing", name: "Publishing", icon: <FaBell />, moduleKey: "socialMediaAutomation" },
      { path: "/social/accounts", name: "Connections", icon: <FaHandshake />, moduleKey: "socialMediaAutomation" },
      { path: "/social/brand", name: "Brand", icon: <FaShieldAlt />, moduleKey: "socialMediaAutomation" },
      { path: "/social/settings", name: "Automation", icon: <MdSettings />, moduleKey: "socialMediaAutomation" },
    ],
  },
  {
    id: "team",
    label: "Team",
    collapsible: true,
    icon: <FaUsers />,
    items: [
      { path: "/attendance", name: "My Attendance", icon: <FaCalendarCheck />, moduleKey: "attendance" },
      { path: "/team-attendance", name: "Team Attendance", icon: <FaUsers />, moduleKey: "teamAttendance" },
      { path: "/hr/departments", name: "Departments", icon: <FaSitemap />, moduleKey: "hrDepartments" },
      { path: "/hr/designations", name: "Designations", icon: <FaBriefcase />, moduleKey: "hrDepartments" },
      { path: "/hr/holidays", name: "Holidays", icon: <FaCalendarDay />, moduleKey: "hrHolidays" },
      { path: "/hr/leave", name: "Leave Balances", icon: <FaUmbrellaBeach />, moduleKey: "hrLeaveManagement" },
    ],
  },
  {
    id: "finance",
    label: "Finance",
    collapsible: true,
    icon: <FaFileInvoiceDollar />,
    items: [
      { path: "/finance/invoices", name: "Invoices", icon: <FaFileInvoiceDollar />, moduleKey: "financeInvoices" },
      { path: "/finance/payments", name: "Payments", icon: <FaHandHoldingUsd />, moduleKey: "financePayments" },
      { path: "/finance/expenses", name: "Expenses", icon: <FaReceipt />, moduleKey: "financeExpenses" },
      { path: "/finance/payroll", name: "Payroll", icon: <FaMoneyCheckAlt />, moduleKey: "payroll" },
      { path: "/finance/salary-structures", name: "Salary Structures", icon: <FaCoins />, moduleKey: "payroll" },
      { path: "/finance/ledger", name: "Ledger", icon: <FaBook />, moduleKey: "financeLedger" },
      { path: "/finance/commissions", name: "Commissions", icon: <FaPercent />, moduleKey: "financeCommissions" },
      { path: "/finance/tax", name: "Tax & Revenue", icon: <FaChartBar />, moduleKey: "financeTax" },
      { path: "/finance/reports", name: "Reports", icon: <FaChartBar />, moduleKey: "financeReports" },
    ],
  },
  {
    id: "settings",
    label: "Settings",
    collapsible: true,
    icon: <MdSettings />,
    items: [
      { path: "/settings", name: "Workspace", icon: <MdSettings />, moduleKey: "settings" },
      { path: "/pipeline-stages", name: "Pipeline Stages", icon: <MdOutlineSecurity />, moduleKey: "pipelineStages" },
      { path: "/notification-engine", name: "Notifications", icon: <FaBell />, moduleKey: "notificationEngine" },
      {
        path: "/registeruser",
        name: "Employees",
        icon: <MdPerson />,
        moduleKey: "employees",
        matchPaths: ["/adduser", "/edituser", "/hr/employees"],
      },
      {
        path: "/branches",
        name: "Branches",
        icon: <FaCodeBranch />,
        moduleKey: "branches",
        matchPaths: ["/addbranch", "/editbranch"],
      },
    ],
  },
  {
    id: "support",
    label: "Support",
    items: [
      { path: "/quicksupport", name: "Quick Support", icon: <FaPhoneSquareAlt />, moduleKey: "quickSupport" },
    ],
  },
];

/** Employee menu — workflow-focused groups. */
export const employeeMenuGroups = [
  {
    id: "overview",
    label: "Overview",
    items: [
      { path: "/dashboard", name: "Dashboard", icon: <FaHome />, moduleKey: "dashboard" },
    ],
  },
  {
    id: "leads",
    label: "Leads & Pipeline",
    collapsible: true,
    defaultOpen: true,
    icon: <FaTasks />,
    items: [
      { path: "/leadassigned", name: "Leads", icon: <FaTasks />, moduleKey: "assignedLeads" },
      { path: "/pendingfollowups", name: "Pending Follow-ups", icon: <FaBell />, moduleKey: "pendingFollowUps" },
      { path: "/calendar", name: "Calendar", icon: <FaCalendarCheck />, moduleKey: "assignedLeads" },
      { path: "/kanban", name: "Kanban Pipeline", icon: <FaColumns />, moduleKey: "kanban" },
    ],
  },
  {
    id: "immigration",
    label: "Immigration",
    collapsible: true,
    icon: <FaFolderOpen />,
    items: [
      { path: "/immigration/cases", name: "Cases", icon: <FaFolderOpen />, moduleKey: "cases" },
      { path: "/immigration/appointments", name: "Appointments", icon: <FaCalendarCheck />, moduleKey: "appointments" },
    ],
  },
  {
    id: "education",
    label: "Education",
    collapsible: true,
    icon: <FaGraduationCap />,
    items: [
      { path: "/education/students", name: "Students", icon: <FaUserCheck />, moduleKey: "students" },
      { path: "/education/admissions", name: "Admissions", icon: <FaFileSignature />, moduleKey: "admissions" },
      { path: "/education/counselling", name: "Counselling", icon: <FaPhoneSquareAlt />, moduleKey: "educationCounselling" },
    ],
  },
  {
    id: "team",
    label: "Team",
    collapsible: true,
    icon: <FaCalendarCheck />,
    items: [
      { path: "/attendance", name: "My Attendance", icon: <FaCalendarCheck />, moduleKey: "attendance" },
      { path: "/settings", name: "Settings", icon: <MdSettings />, moduleKey: "settings" },
    ],
  },
  {
    id: "support",
    label: "Support",
    items: [
      { path: "/quicksupport", name: "Quick Support", icon: <FaPhoneSquareAlt />, moduleKey: "quickSupport" },
    ],
  },
];

/** Channel partner portal — inventory + own customers only. */
export const partnerMenuGroups = [
  {
    id: "marketplace",
    label: "Marketplace",
    items: [
      { path: "/partner/dashboard", name: "Dashboard", icon: <FaChartBar /> },
      { path: "/partner/listings", name: "Published properties", icon: <FaBuilding /> },
      { path: "/partner/register-customer", name: "Register customer", icon: <FaUserPlus /> },
      { path: "/partner/leads", name: "My leads", icon: <FaTasks /> },
      { path: "/partner/visits", name: "Site visits", icon: <FaCalendarCheck /> },
      { path: "/partner/bookings", name: "Bookings", icon: <FaFileSignature /> },
      { path: "/partner/commissions", name: "Commissions", icon: <FaPercent /> },
    ],
  },
];

/** Super Admin platform menu. */
export const superAdminMenuGroups = [
  {
    id: "platform",
    label: "Platform",
    items: [
      { path: "/dashboard", name: "Platform overview", icon: <FaHome /> },
      { path: "/client", name: "Agencies", icon: <MdPersonOutline /> },
      { path: "/subscriptionplans", name: "Subscription plans", icon: <MdOutlineCardMembership /> },
    ],
  },
  {
    id: "social-admin",
    label: "Social media",
    collapsible: true,
    defaultOpen: false,
    icon: <FaShareAlt />,
    items: [
      { path: "/superadmin/social/ai-usage", name: "AI usage logs", icon: <FaChartBar /> },
      { path: "/superadmin/social/provider-costs", name: "Provider costs", icon: <FaCoins /> },
    ],
  },
  {
    id: "configuration",
    label: "Configuration",
    collapsible: true,
    defaultOpen: true,
    icon: <MdSettings />,
    items: [
      { path: "/settings", name: "Platform settings", icon: <MdSettings /> },
      { path: "/notification-engine", name: "Notifications", icon: <FaBell /> },
      { path: "/documents", name: "Documents", icon: <FaFilePdf /> },
    ],
  },
];

/**
 * Filter menu groups/items by module access and role rules.
 */
export function filterMenuGroups(groups, { roleNum, roleId, isModuleEnabled, hidePaths = [] }) {
  const superAdmin = roleNum === 1 || isSuperAdminRole(roleId);

  const filterItem = (item) => {
    if (hidePaths.includes(item.path)) return false;
    if (superAdmin) return true;
    if (!item.moduleKey) return true;
    return isModuleEnabled(item.moduleKey);
  };

  return groups
    .map((group) => ({
      ...group,
      items: (group.items || []).filter(filterItem),
    }))
    .filter((group) => group.items.length > 0);
}
